import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50f43009"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "name-butterfly" }
const _hoisted_2 = { class: "container min-h-full m-auto flex flex-col text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "my-auto" }, "Name your butterfly", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex flex-col flex-none" }
const _hoisted_6 = ["readonly"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_8 = { class: "flex flex-row flex-none" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Uh-Oh. ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" This is a family friendly interactive. ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Please type a different Name. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_screen_keyboard = _resolveComponent("screen-keyboard")!
  const _component_router_link_button = _resolveComponent("router-link-button")!
  const _component_back_button = _resolveComponent("back-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_alert = _resolveComponent("alert")!
  const _directive_tap = _resolveDirective("tap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("img", {
        src: _ctx.butterflySrc,
        class: "mx-8 object-contain"
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          class: "flex-row my-auto mx-6",
          onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmit($event)))
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.butterflyName) = $event)),
            readonly: _ctx.showKeyboard,
            placeholder: "Type a Name",
            class: "name-butterfly__input"
          }, null, 8, _hoisted_6), [
            [_vModelText, _ctx.butterflyName]
          ])
        ], 32),
        (_ctx.showKeyboard)
          ? (_openBlock(), _createBlock(_component_screen_keyboard, {
              key: 0,
              modelValue: _ctx.butterflyName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.butterflyName) = $event))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createVNode(_component_router_link_button, {
        class: "mx-auto mt-auto",
        disabled: !_ctx.canGoNext
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["disabled"]), [
        [_directive_tap, _ctx.onClickNext]
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: _ctx.prevRoute,
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createVNode(_component_back_button, {
              class: "mr-auto",
              onClick: navigate
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createVNode(_component_alert, { show: _ctx.showAlert }, {
      default: _withCtx(() => [
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}